// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

import { getLocalizedData } from '../../utils/CatalogUtils';

export default class ProductOptionValue extends ApiObject {
  static DEFAULT_STOCK = 999;

  id: string = '';

  // the real used value will be the one returned by the getter
  _name: string = '';

  localizedNames: Array<> = [];

  additionalPrice: number = 0;

  baseAdditionalPrice: number = 0;

  allergens: [];

  stock: number = ProductOptionValue.DEFAULT_STOCK;

  set name(name) {
    this._name = name;
  }

  get name() {
    return getLocalizedData(this.localizedNames) || this._name || '';
  }

  postJsonAssignation(data: Object) {}

  //
  // Validation
  //

  /**
   * Verify that the object is correct
   */
  isValid(): boolean {
    // TODO: update
    return this.validateName() && this.validateAdditionalPrice();
  }

  validateName(): boolean {
    if (_.isEmpty(this.localizedNames)) {
      return false;
    }

    let isValid = false;

    _.forEach(this.localizedNames, (localizedName) => {
      if (!_.isEmpty(localizedName.text)) {
        isValid = true;
      }
    });

    return isValid;
  }

  validateAdditionalPrice(): boolean {
    return (
      !_.isNaN(parseFloat(this.additionalPrice)) && this.additionalPrice >= 0
    );
  }

  static validationErrors = {
    name: 'Le nom ne peut être vide',
    additionalPrice: 'Le prix additionnel est invalide',
  };

  getValidationErrors(): Object {
    const validationErrors = ProductOptionValue.validationErrors;
    const errors = {};

    if (!this.validateName()) {
      errors.name = validationErrors.name;
    }

    if (!this.validateAdditionalPrice()) {
      errors.price = validationErrors.additionalPrice;
    }

    return errors;
  }

  toggleAvailibility() {
    if (this.stock === 0) {
      this.stock = ProductOptionValue.DEFAULT_STOCK;
    } else {
      this.stock = 0;
    }
  }

  haveStock(): boolean {
    return this.stock !== 0;
  }
}
